var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSupplier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F8F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7188 24.0234H18.2812L15.6232 24.6242C13.8425 25.0267 12.5781 26.6088 12.5781 28.4344V29.6094H27.4219V28.4344C27.4219 26.6088 26.1575 25.0267 24.3768 24.6243L21.7188 24.0234Z",
    fill: "#6E83B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.5234C21.3197 26.5234 22.403 25.4955 22.4932 24.1985L21.7188 24.0234H18.2813L17.5068 24.1985C17.5971 25.4955 18.6805 26.5234 20 26.5234Z",
    fill: "#EDEFF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2812 22.0781V24.0239C18.2812 24.9732 19.0507 25.7427 20 25.7427C20.9493 25.7427 21.7188 24.9732 21.7188 24.0239V22.0781H18.2812Z",
    fill: "#FFD3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2812 22.9643C18.8086 23.1928 19.3897 23.3198 20 23.3198C20.6103 23.3198 21.1914 23.1929 21.7188 22.9643V22.0771H18.2812V22.9643Z",
    fill: "#FCB98B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5547 16.6406V18.9844C23.5547 20.9476 21.9632 22.5391 20 22.5391C18.0368 22.5391 16.4453 20.9476 16.4453 18.9844V16.6406H23.5547Z",
    fill: "#FFD3B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6172 16.6406L23.5547 18.9844V16.6406H22.6172Z",
    fill: "#6E83B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3828 16.6406L16.4453 18.9844V16.6406H17.3828Z",
    fill: "#6E83B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8984 18.5547H16.4453V16.6406H15.8984C15.6827 16.6406 15.5078 16.8155 15.5078 17.0312V18.1641C15.5078 18.3798 15.6827 18.5547 15.8984 18.5547Z",
    fill: "#FFD3B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1016 18.5547H23.5547V16.6406H24.1016C24.3173 16.6406 24.4922 16.8155 24.4922 17.0312V18.1641C24.4922 18.3798 24.3173 18.5547 24.1016 18.5547Z",
    fill: "#FFD3B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3025 28.4375H24.6931V29.6094H24.3025V28.4375Z",
    fill: "#466089"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3069 28.4375H15.6975V29.6094H15.3069V28.4375Z",
    fill: "#466089"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8203 16.6406V15.1172C15.8203 12.8125 17.6953 10.9375 20 10.9375C22.3047 10.9375 24.1797 12.8125 24.1797 15.1172V16.6406H15.8203Z",
    fill: "#FFE352"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.4834C22.1702 15.4834 25.2344 15.9377 25.2344 15.9377V16.6408H20H14.7656V15.9377C14.7656 15.9377 17.8298 15.4834 20 15.4834Z",
    fill: "#FFE352"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.9375C19.15 10.9375 18.359 11.1932 17.6984 11.6307L17.9453 15.5816H22.0547L22.3016 11.6307C21.6411 11.1932 20.85 10.9375 20 10.9375Z",
    fill: "#FFB236"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4953 15.0203H21.5046L21.7724 10.7354C21.2244 10.5138 20.6264 10.3906 20 10.3906C19.3735 10.3906 18.7755 10.5138 18.2275 10.7354L18.4953 15.0203Z",
    fill: "#FFE352"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7109 27.0962V24.4738L22.6172 24.2266V27.0704C22.6172 27.9333 21.9176 28.6329 21.0547 28.6329H18.9453C18.0824 28.6329 17.3828 27.9333 17.3828 27.0704V24.2266L16.2891 24.4738V27.0962C16.2891 27.4103 16.1945 27.717 16.0175 27.9764L15.7031 28.4376V29.6095H24.2969V28.4376L23.9825 27.9764C23.8055 27.717 23.7109 27.4102 23.7109 27.0962Z",
    fill: "#FFE352"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSupplier);
export default __webpack_public_path__ + "static/media/material-supplier.a0e58b1c243dea8cd9cf091f3cefb49d.svg";
export { ForwardRef as ReactComponent };